module.exports = __webpack_public_path__ + "img/transportation-network.99c72d78.jpg";